define('GiftCertificateVariableAmount.View', [
    'Backbone',
    'giftcertificatevariableamount_view.tpl',
    'GlobalViews.Message.View',
    'GlobalViews.Modal.View',
    'Backbone.CompositeView',
    'jQuery',
    'underscore',
    'Utils'
], function GiftCertificateVariableAmountView(
    Backbone,
    giftCertificateVariableAmountViewTpl,
    GlobalViewsMessageView,
    GlobalViewsModalView,
    BackboneCompositeView,
    jQuery,
    _
) {
    'use strict';

    return Backbone.View.extend({

        template: giftCertificateVariableAmountViewTpl,

        contextDataRequest: ['item'],

        initialize: function initialize(options) {
            var self = this;

            self.pdp = options.pdp;
            self.cart = options.cart;
            self.itemInfo = self.pdp.getItemInfo();
            self.application = options.application;
            self.layout = options.layout;

            self.pdp.on('afterShowContent', function afterShowContent() {
                var giftValue = jQuery("[name='custcol_certificate_amount']").val();
                self.validateAddtoCartButton(giftValue);
                if (giftValue !== undefined && giftValue !== '') {
                    self.showErrorMessage(giftValue);
                }
            });

            self.pdp.on('afterOptionSelection', function afterOptionSelection() {
                var giftValue = jQuery("[name='custcol_certificate_amount']").val();
                self.validateAddtoCartButton(giftValue);
                self.validateIfEmptyGiftValue(giftValue);
                if (giftValue !== undefined && giftValue !== '') {
                    self.showErrorMessage(giftValue);
                }
            });
        },

        validateAddtoCartButton: function validateAddtoCartButton(giftValue) {
            if ((giftValue === undefined || giftValue === '') && (this.itemInfo.item.keyMapping_isGiftCertWithVariableAmount)) {
                jQuery('.cart-add-to-cart-button-button').prop('disabled', true);
            } else {
                jQuery('.cart-add-to-cart-button-button').prop('disabled', false);
            }
        },

        validateIfEmptyGiftValue: function validateIfEmptyGiftValue(giftValue) {
            if (giftValue === undefined || giftValue === '') {
                this.globalViewMessage({errormsg: 'Gift Certificate Amount should not be empty'});
            }
        },

        showErrorMessage: function showErrorMessage(giftValue, responseMsg) {
            var self = this;
            var minValue = this.itemInfo.item.keyMapping_minimumGiftValue;
            var maxValue = this.itemInfo.item.keyMapping_maximumGiftValue;
            var responseMsg = self.validateGiftValue(giftValue, minValue, maxValue);

            if (self.itemInfo.item.keyMapping_isGiftCertWithVariableAmount) {
                if (!responseMsg.status) {
                    self.globalViewMessage(self.validateGiftValue(giftValue, minValue, maxValue));
                    jQuery('.cart-add-to-cart-button-button').prop('disabled', true);
                } else {
                    jQuery('.global-views-message-button').click();
                    jQuery('.cart-add-to-cart-button-button').prop('disabled', false);
                }
            }
        },

        globalViewMessage: function globalViewMessage(message) {
            var globalViewMessages = new GlobalViewsMessageView({
                message: _.translate(message.errormsg),
                type: 'error',
                closable: true
            });
            var msgContainerParent = jQuery('.errormsg');
            msgContainerParent.html(globalViewMessages.render().$el.html());
        },

        validateGiftValue: function validateGiftValue(giftValue, min, max) {
            var userInputValue = parseInt(giftValue, 10);
            var minimumGiftValue = parseInt(min, 10);
            var maximumGiftValue = parseInt(max, 10);
            var response = '';

            if (this.itemInfo.item.keyMapping_isGiftCertWithVariableAmount) {
                if (userInputValue) {
                    if ((minimumGiftValue !== 0) && (maximumGiftValue !== 0)) {
                        if (userInputValue < minimumGiftValue) {
                            response = {
                                errormsg: _.translate('Gift Certificate Amount is less than the minimum'),
                                status: false
                            };
                        } else if (userInputValue > maximumGiftValue) {
                            response = {
                                errormsg: _.translate('Gift Certificate Amount exceeds the maximum'),
                                status: false
                            };
                        } else {
                            response = {
                                errormsg: null,
                                status: true
                            };
                        }
                    } else if ((minimumGiftValue !== 0) && (maximumGiftValue === 0)) {
                        if (userInputValue < minimumGiftValue) {
                            response = {
                                errormsg: _.translate('Gift Certificate Amount is less than the minimum'),
                                status: false
                            };
                        } else {
                            response = {
                                errormsg: null,
                                status: true
                            };
                        }
                    } else if ((minimumGiftValue === 0) && (maximumGiftValue !== 0)) {
                        if (userInputValue > maximumGiftValue) {
                            response = {
                                errormsg: _.translate('Gift Certificate Amount exceeds the maximum'),
                                status: false
                            };
                        } else {
                            response = {
                                errormsg: null,
                                status: true
                            };
                        }
                    } else { // validate if no min and max gift variable
                        response = {
                            errormsg: null,
                            status: true
                        };
                    }
                } else {
                    response = {
                        errormsg: _.translate('Gift Certificate Amount should not be empty'),
                        status: false
                    };
                }
            } else {
                response = {
                    errormsg: _.translate('Not A valid Item'),
                    status: true
                };
            }

            return response;
        },

        getContext: function getContext() {
            var self = this;

            self.cart.on('beforeAddLine', function beforeAddLine(line) { // eslint-disable-line consistent-return
                var giftValue = jQuery("[name='custcol_certificate_amount']").val();
                var responseMessage;
                if (line.line.item.itemtype === 'GiftCert') {
                    if (self.pdp.getItemInfo().item.custitem_is_variable_amount) { // validate if item has gift cert
                        responseMessage = self.validateGiftValue(giftValue,
                            self.pdp.getItemInfo().item.keyMapping_minimumGiftValue,
                            self.pdp.getItemInfo().item.keyMapping_maximumGiftValue
                        );
                        self.layout.on('afterShowContent', function() {
                            jQuery('[data-view="Line.Price"]').hide();
                        });
                        if (!responseMessage.status) {
                            return jQuery.Deferred().reject(new Error(
                                _.translate(responseMessage.errormsg))
                            );
                        }
                    }
                }
            });

            return {
                message: _.translate(
                    this.itemInfo.item.keyMapping_warningMessage,
                    this.itemInfo.item.keyMapping_minimumGiftValue,
                    this.itemInfo.item.keyMapping_maximumGiftValue
                ),
                isGiftCertWithVariableAmount: this.itemInfo.item.keyMapping_isGiftCertWithVariableAmount,
                hasMaxMinGiftValue: this.itemInfo.item.keyMapping_hasMaxMinGiftValue,
            };
        }
    });
});
